import React from "react";
import './LogIn.css';
import {IonPage} from "@ionic/react";
import FormLogIn from "../../components/login/FormLogIn";

/**
 * Component to connect
 */
class LogIn extends React.Component {

    render() {
        return (
            <IonPage>
                <div id="mainContainer"/>
                <div id="formContainer">
                    <FormLogIn/>
                    <img src="./assets/illustration/logo/logo-fonroche-lighting-txt-blanc-horiz.png" id="logInLogoEnterprise"/>
                </div>
            </IonPage>
        );
    }

}
export default LogIn;
